/**
 * Created by Ning Jiang on 4/4/2019.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {
    ReelStopPresentationController
} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {
    IndividualWinPresentationController
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {BackgroundAnimationsController} from "./background/BackgroundAnimationsController";
import {WildNudgeBackground} from "./background/WildNudgeBackground";
import {FreespinsLeftIndicator} from "./freespinsleft/FreespinsLeftIndicator";
import {MultiplierIndicator} from "./multiplier/MultiplierIndicator";
import {WildNudgeNudgeReelController} from "./reel/nudgereel/WildNudgeNudgeReelController";
import {WildNudgeNudgeReelPartAnimator} from "./reel/nudgereel/WildNudgeNudgeReelPartAnimator";
import {
    RandomFeatureAttentionController
} from "./reelstoppresentation/randomfeatureattention/RandomFeatureAttentionController";
import {
    RandomFeatureIndicatorController
} from "./reelstoppresentation/randomfeatureindicator/RandomFeatureIndicatorController";
import {WildNudgeReelAttentionController} from "./reelstoppresentation/reelattention/WildNudgeReelAttentionController";
import {
    WildNudgeScatterAttentionController
} from "./reelstoppresentation/scatterattention/WildNudgeScatterAttentionController";
import {WildLandingPresentationController} from "./reelstoppresentation/wildlanding/WildLandingPresentationController";
import {BurningMReelSymbol} from "./reelsymbol/BurningMReelSymbol";
import {BurningWildReelSymbol} from "./reelsymbol/BurningWildReelSymbol";
import {SymbolBurstAnimator} from "./reelsymbol/SymbolBurstAnimator";
import {WildNudgeReelSymbol} from "./reelsymbol/WildNudgeReelSymbol";
import {WildNudgeScatterReelSymbol} from "./reelsymbol/WildNudgeScatterReelSymbol";
import {WildNudgeFreespinIntroController} from "./screen/freespinintro/WildNudgeFreespinIntroController";
import {WildNudgeFreespinIntroView} from "./screen/freespinintro/WildNudgeFreespinIntroView";
import {WildNudgeFreespinOutroController} from "./screen/freespinoutro/WildNudgeFreespinOutroController";
import {WildNudgeFreespinOutroView} from "./screen/freespinoutro/WildNudgeFreespinOutroView";
import {WildNudgeParsedGameData} from "./server/data/WildNudgeParsedGameData";
import {WildNudgeParsedInitData} from "./server/data/WildNudgeParsedInitData";
import {WildNudgeServerDataParser} from "./server/WildNudgeServerDataParser";
import {WildNudgeFontConfig} from "./WildNudgeFontConfig";
import {WildNudgeGameAssets} from "./WildNudgeGameAssets";
import {WildNudgeGameConfig} from "./WildNudgeGameConfig";
import {WildNudgeSoundConfig} from "./WildNudgeSoundConfig";
import {WildNudgeBigWinController} from "./winpresentation/bigwin/WildNudgeBigWinController";
import {CommonWinPresentationController} from "./winpresentation/common/CommonWinPresentationController";
import {WildNudgeIndividualWPController} from "./winpresentation/individual/WildNudgeIndividualWPController";
import {WildNudgeInitialWPController} from "./winpresentation/initial/WildNudgeInitialWPController";
import {NudgeScatterWPController} from "./winpresentation/nudgescatter/NudgeScatterWPController";
import {
    WildNudgeNudgeStackedSymbolWPController
} from "./winpresentation/nudgestacked/WildNudgeNudgeStackedSymbolWPController";
import {ScatterWinPresentationController} from "./winpresentation/scatterwin/ScatterWinPresentationController";

export class WildNudgeGameModuleConfig implements IGameModuleConfig {

    public static instance:WildNudgeGameModuleConfig = new WildNudgeGameModuleConfig();

    GAME_CONFIG:IGameConfig = WildNudgeGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = WildNudgeSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = WildNudgeFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = WildNudgeGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new WildNudgeServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => new WildNudgeParsedInitData(data, <WildNudgeServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => new WildNudgeParsedGameData(data, <WildNudgeServerDataParser>dataParser);

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new WildNudgeNudgeReelController(reelId);

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.
    REEL_PART_ANIMATOR:(reelId:number) => ReelPartAnimator = reelId => new WildNudgeNudgeReelPartAnimator(reelId);

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):StateReelSymbol => {
            if(symName.charAt(0) === ReelSymbolName.WILD) {
                return new BurningWildReelSymbol(symName, reelId, state);
            }
            if(symName.charAt(0) === "M") {
                return new BurningMReelSymbol(symName, reelId, state);
            }
            if(symName === ReelSymbolName.SCATTER) {
                return new WildNudgeScatterReelSymbol(symName, reelId, state);
            }
            return new WildNudgeReelSymbol(symName, reelId, state);
        });

    SCREENS:(() => ScreenController)[] = [
        () => new WildNudgeFreespinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new WildNudgeFreespinIntroView({
                    layer : WildNudgeGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, false);
            }
        }),
        () => new WildNudgeFreespinOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new WildNudgeFreespinOutroView({
                    layer : WildNudgeGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1.2,
                    portraitScale : 1.2
                }, false);
            }
        })
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new FreespinZeroBetController(),
        () => new RespinZeroBetController()
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new WildNudgeScatterAttentionController(index, {
            numOfScattersToWin : 3,
            scattersMap : [false, true, true, true, false]
        }),
        (index:number) => new BackgroundAnimationsController(index),
        (index:number) => new WildLandingPresentationController(index),
        (index:number) => new RandomFeatureIndicatorController(index),
        (index:number) => new RandomFeatureAttentionController(index),
        (index:number) => new WildNudgeReelAttentionController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new WildNudgeNudgeStackedSymbolWPController(indexes)],
        [indexes => new WildNudgeInitialWPController(indexes)],
        [indexes => new WildNudgeBigWinController(indexes)],
        [indexes => new NudgeScatterWPController(indexes)],
        [indexes => new ScatterWinPresentationController(indexes)]
    ];
    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new WildNudgeIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        const background = new WildNudgeBackground({
            layer : WildNudgeGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : "mainBackground", offset : new PIXI.Point(-201, -653)},
                FREESPIN : {image : "mainBackground", offset : new PIXI.Point(-201, -653)}
            },
            stretch : false
        });

        const multiplier = new MultiplierIndicator();
        const freespinsLeft = new FreespinsLeftIndicator();
        const symbolBurstAnimator = new SymbolBurstAnimator();
        const commonWinPresentationController = new CommonWinPresentationController();

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(WildNudgeGameModuleConfig.instance) {
            throw new Error("WildNudgeGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}